import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Row, Col, ListGroup, Card } from 'react-bootstrap';
import { useGetBagDetailsQuery } from '../slices/bagsApiSlice';
import Loader from '../components/Loader';
import Message from '../components/Message';
import Meta from '../components/Meta';
import BagCarousel from '../components/BagCarousel';

const BagScreen = () => {
  const { id: bagId } = useParams();
  const { data: bag, isLoading, error } = useGetBagDetailsQuery(bagId);

  const renderBagDetails = () => (
    <>
      <Meta title={bag.date} description={bag.status} />
      <Row>
        <Col md={6}>
          {/* Display bag images using BagCarousel */}
          {bag.images && bag.images.length > 0 ? (
            <BagCarousel images={bag.images} />
          ) : (
            <Message variant="info">No images available for this bag</Message>
          )}
        </Col>
        <Col md={3}>
          <ListGroup variant="flush">
            <ListGroup.Item>
              <h3>{bag.accountName}</h3>
            </ListGroup.Item>
            <ListGroup.Item>Details: {bag.details}</ListGroup.Item>
            <ListGroup.Item>Amount: {bag.number}</ListGroup.Item>
            <ListGroup.Item>
              Details: {bag.details}
            </ListGroup.Item>
            <ListGroup.Item>User:{bag.username}</ListGroup.Item>
          </ListGroup>
        </Col>
        <Col md={3}>
          <Card>
            <ListGroup variant="flush">
              <ListGroup.Item>
                <Row>
                  <Col>Amount:</Col>
                  <Col>
                    <strong>{bag.number}</strong>
                  </Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>User:</Col>
                  <Col>
                    {bag.username}
                  </Col>
                </Row>
              </ListGroup.Item>
            </ListGroup>
          </Card>
          <div className="bag-images mt-3">
                    <h6>Images:</h6>
                    <div className="image-thumbnails">
                      {bag.images?.map((image, index) => (
                        <img
                          key={index}
                          src={image}
                          alt={` ${index + 1}`}
                          className="thumbnail-img"
                          style={{
                            width: '50px',
                            height: '50px',
                            marginRight: '5px',
                            borderRadius: '5px',
                          }}
                        />
                      ))}
                    </div>
                  </div>
        </Col>
      </Row>
    </>
  );

  return (
    <>
      <Link className="btn btn-light my-3" to="/">
        Go Back
      </Link>
      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message variant="danger">
          {error?.data?.message || error.error}
        </Message>
      ) : (
        renderBagDetails()
      )}
    </>
  );
};

export default BagScreen;